/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExtensionOrderImportResultDTOFromJSON, ExtensionOrderImportResultDTOToJSON, } from './ExtensionOrderImportResultDTO';
/**
 * Check if a given object implements the ImportOrdersFromExtensionResponse interface.
 */
export function instanceOfImportOrdersFromExtensionResponse(value) {
    return true;
}
export function ImportOrdersFromExtensionResponseFromJSON(json) {
    return ImportOrdersFromExtensionResponseFromJSONTyped(json, false);
}
export function ImportOrdersFromExtensionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'results': json['results'] == null ? undefined : (json['results'].map(ExtensionOrderImportResultDTOFromJSON)),
    };
}
export function ImportOrdersFromExtensionResponseToJSON(json) {
    return ImportOrdersFromExtensionResponseToJSONTyped(json, false);
}
export function ImportOrdersFromExtensionResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'results': value['results'] == null ? undefined : (value['results'].map(ExtensionOrderImportResultDTOToJSON)),
    };
}
